import { render, staticRenderFns } from "./GameTagModal.vue?vue&type=template&id=13e75fb2&"
import script from "./GameTagModal.vue?vue&type=script&lang=js&"
export * from "./GameTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports